<wr-base-dialog
  [header]="header"
  [status]="mode === 'finish' ? 'success' : 'danger'"
  [submitText]="mode === 'finish' ? 'Abschließen' : 'Stornieren'"
  cancelText="Abbrechen"
  [disableSubmit]="!canSubmit()"
  [submitResponse]="submit.bind(this)">
  @if (taskTitle) {
    <p class="task-title">{{ taskTitle }}</p>
  }
  @if (!hasComment()) {
    <wr-banner status="warning" [icon]="warningIcon" message="Bitte geben Sie einen Kommentar ein."></wr-banner>
  }
  @if (photoMissing()) {
    <wr-banner status="warning" [icon]="warningIcon" message="Bitte laden Sie mindestens ein Foto hoch."></wr-banner>
  }
  <hau-form [formGroup]="form" class="dialog-window">
    <hau-form-field [label]="mode === 'finish' ? 'Kommentar zur Reparatur' : 'Grund der Stornierung'" cols="12">
      <textarea nbInput fullWidth rows="4" formControlName="comment" data-cy="repair-task-close-comment"
                [placeholder]="mode === 'finish' ? 'Was wurde gemacht?' : 'Warum wird der Auftrag storniert?'"></textarea>
    </hau-form-field>
    @if (mode === 'finish') {
      <hau-form-field label="Fotos" cols="12">
        <wr-multi-attachment-control formControlName="attachments" data-cy="repair-task-close-photos"></wr-multi-attachment-control>
      </hau-form-field>
    }
  </hau-form>
</wr-base-dialog>
